import { create } from "zustand";
import { ProfileData } from "@/interface/types";

interface ProfileState {
  profileData: Partial<ProfileData>;
  setProfile: (userData: ProfileData) => void;
  clearProfile: () => void;
}

const useProfileStore = create<ProfileState>((set) => ({
  profileData: {},
  setProfile: (profileData) => {
    set(() => ({ profileData: profileData }));
  },
  clearProfile: () => {
    set(() => ({ profileData: {} }));
  },
}));

export default useProfileStore;
